import { render, staticRenderFns } from "./Comp65t3.vue?vue&type=template&id=67a7df23&scoped=true&"
import script from "./Comp65t3.vue?vue&type=script&lang=js&"
export * from "./Comp65t3.vue?vue&type=script&lang=js&"
import style0 from "./Comp65t3.vue?vue&type=style&index=0&id=67a7df23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a7df23",
  null
  
)

export default component.exports